import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { RateCurve } from '@classes/invest/rate-curve';
import { InvestService } from '@services/invest.service';
import { ProviderType } from '@enums/provider-type.enum';
import { InvestRateType } from '@enums/invest-rate-type.enum';
import { IndiceModeType } from '@enums/indice-mode-type.enum';
import { InvestBbc } from '@classes/invest/invest-bbc/invest-bbc';
import { InvestProjectBbc } from '@classes/invest/invest-bbc/invest-project-bbc';
import { InvestProjectYear } from '@classes/invest/invest-project-year';

@Component({
  selector: 'app-bbc-projects',
  templateUrl: './bbc-projects.component.html',
  styleUrls: ['./bbc-projects.component.scss']
})
export class BbcProjectsComponent implements OnInit, OnDestroy {
    @Input() invest: InvestBbc;
    private investSub: Subscription;

    rateCurve: RateCurve[];
    years: number[];
    isLoading: boolean;
    indiceMode = IndiceModeType;

    constructor(
        private investSrv: InvestService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
        this.initDropdowns();
    }

    onValueChanged(value: number, year: InvestProjectYear, key: string): void {
        if(key === 'loaningAmount' && value === 0) {
            year.loaningTypeCode = null;
        }

        if(key === 'rate') {
            year.rate.value = value;
        } else {
            year[key] = value;
        }

        // this.invest = this.investSrv.calculateBbcTots(this.invest);
        this.investSrv.investChanged.next(this.invest);
    }

    checkError(year: InvestProjectYear, key?: string): boolean {
        // if(year.extraBalance < 0) {
        //     return true;
        // }

        switch(key) {
            // case 'extraFund':
            //     return this.invest.simulation.years.some(y => y.items.find(i => i.code === 'extraFund').value < 0);
            // case 'ordinaryLevy':
            //     return this.testLevyValue(year.year);
            default:
                return false;
        }
    }

    onLoaningTypeChanged(year: InvestProjectYear): void {
        if(year.loaningTypeCode && year.year) {
            const selRate = this.rateCurve.find(o => o.code === year.loaningTypeCode);
            const selYearIndex = selRate.years.findIndex(y => y.year === year.year);

            year.rate = {
                type: InvestRateType.selected,
                value: selRate.years[selYearIndex + 1].value // Get selected year + 1
            };
        }
    }

    onProjectsListChanged(projects: InvestProjectBbc[]): void {
        this.invest.projects = projects;
    }

    onAddYear(project: InvestProjectBbc): void {
        project.years.push(new InvestProjectYear(null));
    }

    onAddProject(): void {
        this.invest.projects.push(new InvestProjectBbc("", null));
    }

    onRemoveProject(i: number): void {
        this.invest.projects.splice(i, 1);
    }

    onRemoveYear(project: InvestProjectBbc, i: number): void {
        project.years.splice(i, 1);

        if(!project.years.length) {
            // create a new blank year
            this.onAddYear(project);
        }
    }

    private initSubscriptions(): void {
        this.investSub = this.investSrv.investChanged
        .subscribe(invest => {
            if(invest && invest.simulation.provider === ProviderType.bbc) {
                this.invest = <InvestBbc>invest;
                this.initDropdowns();
            }
        });
    }

    private initDropdowns(): void {
        if(this.invest) {
            this.rateCurve = [ ...this.invest.rateCurve];

            // get years list without last one
            this.years = this.invest.rateCurve[0].years
            .reduce((returnedYears, year, i, years) => {
                return i < (years.length - 1) ? [... returnedYears, year.year] : [... returnedYears];
            }, []);
        } else {
            this.rateCurve = [];
            this.years = [];
        }
    }

    ngOnDestroy(): void {
        if(this.investSub) {
            this.investSub.unsubscribe();
        }
    }
}
